import { render, staticRenderFns } from "./AddClientForm.vue?vue&type=template&id=0e079c42&"
import script from "./AddClientForm.vue?vue&type=script&lang=ts&"
export * from "./AddClientForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports